import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { meQuery, safeNext, signInOptionsQuery } from '../lib/session.js'

// Not part of the first paint of the app: loaded in its own chunk (spec 004 budget).
const loadSignInPage = () => import('../components/SignInPage.js')
const SignInPage = lazy(loadSignInPage)

export interface SignInSearch {
  next?: string
  error?: string
}

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    ...(typeof search.next === 'string' ? { next: search.next } : {}),
    ...(typeof search.error === 'string' ? { error: search.error } : {}),
  }),
  // Already signed in: go where the link or the guard wanted to go.
  beforeLoad: async ({ context, search }) => {
    // The page's chunk and its options load while the session is checked, not one after the
    // other, which took a network round trip off the first paint.
    void loadSignInPage()
    void context.queryClient.query(signInOptionsQuery).catch(() => undefined)
    const me = await context.queryClient.query(meQuery).catch(() => undefined)
    if (me !== undefined) {
      // href, not to: next is a whole in-app href whose query string must survive.
      throw redirect({ href: safeNext(search.next) })
    }
  },
  component: SignInRoute,
})

function SignInRoute() {
  const search = Route.useSearch()
  return (
    <Suspense fallback={null}>
      <SignInPage next={safeNext(search.next)} error={search.error} />
    </Suspense>
  )
}
